/* eslint-disable jira/filename-case */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore json imports are ts-ignored
import supportedLocales from './locales.json';

export const defaultLocale = 'en_US' as const;
export const french = 'fr_FR' as const;

const locales = Object.keys(supportedLocales).map((locale) => locale.replace('-', '_'));

// Need to specify explicitly because $Keys do not work with arrays, nor with spread operator, nor with lodash/reduce
export type Locale =
	| 'cs_CZ'
	| 'da_DK'
	| 'de_DE' // `en_GB` is the technically correct locale name, but `en_UK` is still used in Jira and is not fully deprecated.
	// When changing the locale via identity, `en_GB` is used, and available in the tenant context.
	| 'en_GB'
	| 'en_UK'
	| 'en_US'
	| 'es_ES'
	| 'et_EE'
	| 'fi_FI'
	| 'fr_FR'
	| 'hu_HU'
	| 'is_IS'
	| 'it_IT'
	| 'ja_JP'
	| 'ko_KR'
	| 'nb_NO'
	| 'nl_NL'
	| 'pl_PL'
	| 'pt_BR'
	| 'pt_PT'
	| 'ro_RO'
	| 'ru_RU'
	| 'sk_SK'
	| 'sv_SE'
	| 'tr_TR'
	| 'zh_CN'
	| 'zh_TW';

// oxlint-disable-next-line typescript/consistent-type-assertions
export default locales as Locale[];

// BCP 47 format uses - instead of _, which is the web standard
export const standardizeLocale = (locale: string): string => locale.replace('_', '-');
